import React, { FC } from 'react';
import { View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import Skeleton from '@v2/elements/Skeleton';
import { DashboardScope } from '@api/domain/types';

import { ROW_LAYOUT } from '@v2/pages/dashboard/common/constants/rows';
import { getRowContainerStyle, rowHasImage } from '@v2/pages/dashboard/common/helpers';
import type { WithBorderRadiusConfig } from '@v2/pages/dashboard/common/types/rows';

interface DashboardOverviewBottomBlockRowSkeletonProps extends WithColor, WithBorderRadiusConfig {
  scope: DashboardScope;
}

const DashboardOverviewBottomBlockRowSkeleton: FC<DashboardOverviewBottomBlockRowSkeletonProps> = ({ C, scope, borderRadiusConfig }) => (
  <View style={getRowContainerStyle(scope, borderRadiusConfig)}>
    <Skeleton
      C={C}
      width={scale(ROW_LAYOUT.badge.size)}
      height={scale(ROW_LAYOUT.badge.size)}
      borderRadius={scale(ROW_LAYOUT.badge.radius)}
      style={{ marginHorizontal: scale(ROW_LAYOUT.badge.marginHorizontal) }}
    />
    {rowHasImage(scope) && (
      <Skeleton
        C={C}
        width={scale(ROW_LAYOUT.image.width)}
        height={scale(ROW_LAYOUT.image.height)}
        borderRadius={scale(ROW_LAYOUT.image.borderRadius)}
        style={{ marginRight: scale(8) }}
      />
    )}
    <Skeleton
      C={C}
      width="60%"
      height={scale(ROW_LAYOUT.skeleton.textHeight)}
      borderRadius={scale(ROW_LAYOUT.skeleton.textRadius)}
      style={{ flex: 1 }}
    />
    <Skeleton
      C={C}
      width={scale(ROW_LAYOUT.skeleton.valueWidth)}
      height={scale(ROW_LAYOUT.skeleton.textHeight)}
      borderRadius={scale(ROW_LAYOUT.skeleton.textRadius)}
    />
  </View>
);

export default ColorWrapper(DashboardOverviewBottomBlockRowSkeleton);
